// 做一些初始化的骚操作
import { isDuApp, isIOS } from '@/utils/getDevice'
import { getGuid, Jockeys } from '@/utils'
// import { getMainHost } from '@/utils/utils'

export default () => {
  /** 解决ios cookie webview 初始请求拿不到cookie的问题 确认ios解决后可删除 **/
  if (process.client) {
    const Cookies = require('js-cookie')
    const duToken = Cookies.get('duToken')
    if (duToken && isDuApp && isIOS) {
      Cookies.set('myDuToken', decodeURIComponent(duToken))
    }
    // @ts-ignore
    window.Cookies = Cookies
  }


  /** ios 使用全局路由打开内嵌h5的webview时左上角为X，与安卓交互不统一(左上角应为返回箭头)，由前端做catch，ios端理由是改动过大；（真是f了） **/
  if (process.client && isDuApp && isIOS) {
    Jockeys.enableHybridBack(false, 1)
  }

  // 本地存储 uuid
  if (process.client) {
    !localStorage.getItem('pcode-uuid') &&
      localStorage.setItem('pcode-uuid', getGuid())
  }
  if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
    const mock = require('@du/mock')
    mock.createProxy({
      mockConfig: process.env.MOCK_CONFIG
    })
  }
}

